import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useStyles } from "./StartNewIssueButton.styles";
import { IStartNewIssueButtonProps } from "./StartNewIssueButtonInterfaces";

export const StartNewIssueButton = ({ handleClick, disabled }: IStartNewIssueButtonProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <button type="button" onClick={handleClick} disabled={disabled} className={classes.button}>
            <Typography variant="h5">
                <span className={classes.message}>
                    <AddCircleOutlineIcon className={classes.icon} />{" "}
                    {t("HMI.failure_details.start_new_issue").toUpperCase()}
                </span>
            </Typography>
        </button>
    );
};
